const mapboxgl = window.mapboxgl;

window.addEventListener('DOMContentLoaded', function () {
  const myMap = document.querySelector('.openstreetmap-cpe');

  if (myMap) {
    setTimeout(function () {
      let center = myMap.getAttribute('data-coords').split(',');
      const zoom = myMap.getAttribute('data-zoom');
      center = [parseFloat(center[1]), parseFloat(center[0])];

      mapboxgl.accessToken = document.querySelector('meta[name="mapbox_token"]').getAttribute('content');
      const myOpenStreetMap = new mapboxgl.Map({
        container: myMap,
        style: 'mapbox://styles/mapbox/light-v10', // stylesheet location
        center: center, // starting position [lng, lat]
        zoom: zoom, // starting zoom
      });

      myOpenStreetMap.addControl(new mapboxgl.NavigationControl());
      myOpenStreetMap.scrollZoom.disable();

      const myMarker = document.createElement('div');
      myMarker.innerHTML =
        '<i class="fas fa-map-marker-alt" title="Centre Paramedical d\'Erpent"><span class="marker-title">Centre Paramedical d\'Erpent</span></i>';
      myMarker.className = 'marker';

      new mapboxgl.Marker(myMarker).setLngLat(center).addTo(myOpenStreetMap);
    }, 500);
  }
});
